var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "container modal-card" }, [
      _vm._m(0),
      _c("div", { staticClass: "modal-card-body" }, [
        _c(
          "form",
          {
            attrs: { id: "externalLogin", novalidate: "true" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onLogin()
              },
            },
          },
          [
            _c(
              "b-field",
              [
                _c("b-input", {
                  ref: "externalLogin",
                  attrs: {
                    name: "email",
                    placeholder: "Usern email",
                    type: "text",
                    icon: "user",
                  },
                  model: {
                    value: _vm.email,
                    callback: function ($$v) {
                      _vm.email = $$v
                    },
                    expression: "email",
                  },
                }),
              ],
              1
            ),
            _c(
              "button",
              {
                staticClass: "button is-primary is-fullwidth",
                class: { "is-loading": _vm.isLoading },
                attrs: { type: "submit" },
              },
              [_vm._v(" Activate ")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" First time Azure user connection "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }